import moment from 'moment';
import { FORMAT } from 'constants.js';
import {isNumeric} from 'utils';

export default ({ value }) => moment(isNumeric(value) ? value * 1000 : value).format(FORMAT.DATE_TIME);
